import React from 'react'
import PropTypes from 'prop-types'

import { Text } from '../Text'
import S from './Radio.styled'

const Radio = ({
  className = '',
  value = '',
  groupName,
  isChecked = false,
  isDisabled = false,
  label = '',
  onClick = () => {},
  onChange = () => {},
  onBlur = () => {},
  accentColor,
  onKeyDown: customOnKeyDown = () => {},
}) => {
  const radioId = `radio-${Math.random().toString(36).slice(2, 11)}`

  const onKeyDown = ({ key, target }) => {
    if (key === 'Enter') {
      target.click()
    }
    customOnKeyDown({ key, target })
  }

  const a11yProps = {
    id: radioId,
  }

  if (isDisabled) {
    a11yProps['aria-disabled'] = true
  }

  return (
    <S.Radio
      as="label"
      htmlFor={radioId}
      onMouseDown={(e) => e.preventDefault()}
      className={className}
      onBlur={onBlur}
      isDisabled={isDisabled}
      data-disabled={isDisabled}
      data-active={isChecked}
      accentColor={accentColor}
    >
      <div className="radio-wrapper">
        <S.Input
          {...a11yProps}
          type="radio"
          value={value}
          name={groupName}
          checked={isChecked}
          disabled={isDisabled}
          onClick={onClick}
          onKeyDown={onKeyDown}
          onChange={onChange}
          accentColor={accentColor}
        />
        <S.Checkmark
          className="checkmark"
          accentColor={accentColor}
          aria-hidden="true"
        />
      </div>
      <Text as="span" size="l">
        {label}
      </Text>
    </S.Radio>
  )
}

Radio.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  groupName: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  accentColor: PropTypes.string,
  role: PropTypes.string,
}

export default Radio
